import React, { useEffect } from "react";
import cn from "classnames";
import styles from "./NumberInput.module.scss";
import { inputTypes } from "../constants";
import { withTargetValueFromEvent } from "../utils/input";
import { addStyle } from "./utils";

const withoutComasAndDotsValue = (v) =>
  v ? v.replace(",", "").replace(".", "").replace(/\D/g, "") : "";

export const PositiveIntegerNumberInput = ({
  onChange,
  onClick,
  inputRef,
  value,
  invalid,
  minNumber,
  maxNumber,
  disabled,
  onKeyUp,
  onKeyDown,
}) => {
  useEffect(() => {
    if (Number(value) < Number(0)) onChange(minNumber);
    if (Number(value) > maxNumber) onChange(maxNumber);
  }, [value, maxNumber, minNumber, onChange]);

  return (
    <div
      type={inputTypes.number}
      className={cn(
        styles.nummerInput,
        addStyle(disabled, styles.disabled),
        addStyle(invalid ?? false, styles.invalid),
      )}
      onClick={onClick}
    >
      <input
        disabled={disabled}
        onChange={withTargetValueFromEvent((v) =>
          onChange(withoutComasAndDotsValue(v)),
        )}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        ref={inputRef}
        value={value}
        className={styles.nummerTypeInput}
      />
    </div>
  );
};

PositiveIntegerNumberInput.defaultProps = {
  minNumber: 0,
  maxNumber: 999,
  onChange: () => {},
};
